import type { T_ShellSuggestionDefinition } from "./shell-suggestions";

/**
 * Deterministic composer-focus filtering, shared by web and mobile: every
 * whitespace-separated token of the query must appear somewhere in the
 * suggestion text (case-insensitive). Token-wise matching keeps "portfolio
 * events" matching "What events could move my portfolio?" even though the
 * words appear in the opposite order.
 */
export function filterShellSuggestions<
  T extends Pick<T_ShellSuggestionDefinition, "text">,
>(suggestions: readonly T[], query: string): readonly T[] {
  const tokens = query.trim().toLowerCase().split(/\s+/u).filter(Boolean);
  if (tokens.length === 0) return suggestions;
  return suggestions.filter((suggestion) => {
    const haystack = suggestion.text.toLowerCase();
    return tokens.every((token) => haystack.includes(token));
  });
}
